var _defs, _g, _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKanban(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .kanban-cls-2 {\n        fill: transparent;\n      }\n\n      .kanban-cls-3 {\n        fill: currentColor\n      }\n\n      .kanban-cls-4 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "kanban-cls-2",
    d: "M24.357,25H.643A.643.643,0,0,1,0,24.357V.643A.643.643,0,0,1,.643,0H24.357A.643.643,0,0,1,25,.643V24.357A.643.643,0,0,1,24.357,25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "kanban-cls-3",
    d: "M24.357,0H.643A.643.643,0,0,0,0,.643V24.357A.643.643,0,0,0,.643,25H8.117V23.714H1.286V1.286H23.714V23.714H16.883V25h7.474A.643.643,0,0,0,25,24.357V.643A.643.643,0,0,0,24.357,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "kanban-cls-4",
    x: 5.522,
    y: 5.522,
    width: 2.594,
    height: 13.956
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "kanban-cls-4",
    x: 11.203,
    y: 5.522,
    width: 2.594,
    height: 19.478
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "kanban-cls-4",
    x: 16.883,
    y: 5.522,
    width: 2.594,
    height: 15.67
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanban);
export default __webpack_public_path__ + "static/media/kanban.2258f29c.svg";
export { ForwardRef as ReactComponent };